"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withStyles = _interopRequireDefault(require("../../utils/withStyles"));

var _ChevronDown = _interopRequireDefault(require("../../icons/arrows/ChevronDown"));

var _styles = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ExpandableGroup = function ExpandableGroup(_ref) {
  var children = _ref.children,
      classes = _ref.classes,
      expandIcon = _ref.expandIcon,
      header = _ref.header,
      onClick = _ref.onClick,
      open = _ref.open,
      props = _objectWithoutProperties(_ref, ["children", "classes", "expandIcon", "header", "onClick", "open"]);

  return _react["default"].createElement("div", _extends({
    className: classes.root
  }, props), _react["default"].createElement("div", {
    role: "presentation",
    className: classes.header,
    onClick: onClick
  }, header, _react["default"].createElement("div", {
    className: classes.iconContainer
  }, expandIcon)), _react["default"].createElement("div", {
    className: classes.content
  }, _react["default"].createElement("div", null, children)));
};

ExpandableGroup.propTypes = {
  /** Map of rule names and generated class names */
  classes: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,

  /** Children of ExpandableGroup component, children is the actual toggled content (as opposed to header which is also rendered at the same level) */
  children: _propTypes["default"].node.isRequired,

  /** Bool flag to open/close the group */
  open: _propTypes["default"].bool.isRequired,

  /** Callback fired when the group header is clicked */
  onClick: _propTypes["default"].func.isRequired,

  /** Header of the expandable group, can be simple string (default text styling will be applied) or fully composed node (for completely custom header) */
  header: _propTypes["default"].node.isRequired,

  /** Icon to expand/collapse the expandable group */
  expandIcon: _propTypes["default"].node
};
ExpandableGroup.defaultProps = {
  expandIcon: _react["default"].createElement(_ChevronDown["default"], null)
};

var _default = (0, _withStyles["default"])(_styles["default"])(ExpandableGroup);

exports["default"] = _default;